import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(progressiveJackpotsSaga);

import { takeEvery } from 'redux-saga/effects';
import { progressiveJackpotsRequestData } from '../../slices/progressiveJackpots/progressiveJackpots';
import { getCollectionWorker } from '../workers';

function progressiveJackpotsSaga() {
  return _regeneratorRuntime.wrap(function progressiveJackpotsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeEvery(progressiveJackpotsRequestData, getCollectionWorker);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

export default progressiveJackpotsSaga;